import React, { useState } from "react";
import { Chip, Popover, Tooltip, Typography, Stack } from "@mui/material";
import { Zap, Tag } from "lucide-react";

const requiresCode = (promo) => promo.requires_code === true;
const label = (promo) =>
  requiresCode(promo) ? promo.code?.trim() || "CODICE" : "AUTO";
const behavior = (promo) =>
  requiresCode(promo)
    ? "Usa il codice " + label(promo)
    : "Promo applicata automaticamente";
const name = (promo) => promo.name || "Promozione quantità";
function PromoDetails({ promo }) {
  return (
    <Stack spacing={0.5}>
      <Typography variant="body2" fontWeight={600}>
        {name(promo)}
      </Typography>
      <Typography variant="body2">{behavior(promo)}</Typography>
    </Stack>
  );
}
export default function QuantityPromoBadges({ promos = [] }) {
  const [anchor, setAnchor] = useState(null);
  const [selected, setSelected] = useState([]);
  if (!promos.length) return null;
  const shown = promos.length > 3 ? promos.slice(0, 2) : promos;
  const open = (event, list) => {
    setAnchor(event.currentTarget);
    setSelected(list);
  };
  const more = promos.slice(2);
  return (
    <Stack
      direction="row"
      useFlexGap
      flexWrap="nowrap"
      spacing={0.5}
      sx={{
        minWidth: 0,
        flexShrink: 0,
        maxWidth: "70%",
        "& .MuiChip-root": {
          minWidth: 0,
          flexShrink: 1,
          height: 22,
          fontSize: "0.7rem",
          "& .MuiChip-icon": {
            width: 13,
            height: 13,
            flexShrink: 0,
            color: "inherit",
          },
          "& .MuiChip-label": { px: 0.75 },
        },
      }}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
    >
      {shown.map((p) => (
        <Tooltip key={p.id} title={<PromoDetails promo={p} />} describeChild>
          <Chip
            component="button"
            type="button"
            clickable
            size="small"
            variant={requiresCode(p) ? "outlined" : "filled"}
            icon={
              requiresCode(p) ? (
                <Tag aria-hidden="true" />
              ) : (
                <Zap aria-hidden="true" />
              )
            }
            sx={
              requiresCode(p)
                ? {
                    borderColor: "#94a3b8",
                    backgroundColor: "transparent",
                    color: "#334155",
                  }
                : { backgroundColor: "#e0f2fe", color: "#075985" }
            }
            label={label(p)}
            aria-label={label(p) + ": " + name(p) + ". " + behavior(p)}
            aria-haspopup="dialog"
            onClick={(e) => open(e, [p])}
          />
        </Tooltip>
      ))}
      {promos.length > 3 && (
        <Tooltip
          title={
            <Stack spacing={1}>
              {more.map((p) => (
                <PromoDetails key={p.id} promo={p} />
              ))}
            </Stack>
          }
        >
          <Chip
            component="button"
            type="button"
            clickable
            size="small"
            label={"+" + (promos.length - 2)}
            aria-label="Mostra altre promozioni"
            aria-haspopup="dialog"
            onClick={(e) => open(e, more)}
          />
        </Tooltip>
      )}
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        transitionDuration={0}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Stack
          role="dialog"
          aria-label="Promozioni dell’articolo"
          sx={{
            p: 1.5,
            maxWidth: "min(320px, calc(100vw - 32px))",
            overflowWrap: "anywhere",
          }}
          spacing={1}
        >
          {selected.map((p) => (
            <PromoDetails key={p.id} promo={p} />
          ))}
        </Stack>
      </Popover>
    </Stack>
  );
}
